module.exports = __webpack_public_path__ + "img/Gambetti_DX.232d9c62.png";